import api from "../Configuration/ApiConfig";

const ChatService = {
  GetChat: (itemData) => {
    const request = api.post('Chat/GetChat', itemData)
    return request.then((response) => {
      return response.data
    })
  },
  CreateChat: (itemData) => {
    const request = api.post("Chat/CreateChat", itemData);
    return request.then((response) => {
      return response.data;
    });
  },
  UpdateChat: (itemData) => {
    const request = api.put("Chat/UpdateChat", itemData);
    return request.then((response) => {
      return response.data;
    });
  },
}
export default ChatService;